import { useGetFreshStrawFertilizationsQuery } from '@/app/services/freshStrawRest';

/**
 * Session-keyed query hooks for the fresh-straw module. Wraps the
 * `/api/fresh-straw/*` RTK Query endpoints from `freshStrawRest.ts` with
 * shapes convenient for the page components to consume.
 *
 * Historical note: these used to wrap a separate generated embryo-service
 * client at a different base URL. That service has been retired — every
 * fresh-straw backend path now lives on nucleus-api under
 * `/api/fresh-straw/*`, so the hooks are thin pass-throughs now.
 */

export interface FreshStrawFertilizationsArgs {
  fertDate: string | undefined;
  fertSite?: string;
  accountId: string | undefined;
  freshShipmentId?: string;
}

export const useFreshStrawFertilizations = (
  args: FreshStrawFertilizationsArgs,
) =>
  useGetFreshStrawFertilizationsQuery(
    {
      fertilizationDate: args.fertDate ?? '',
      fertilizationSite: args.fertSite,
      accountId: args.accountId,
      freshShipmentId: args.freshShipmentId,
    },
    { skip: !args.fertDate || !args.accountId },
  );
